// CFS.js

import React from 'react';
import './CFS.css';

const CFS = () => {
  return (
    <div className="cfs-container">
      <p className="cfs-text">COLD FORM SECONDARY</p>
      <p className="under-construction">Under Construction - Check back later!</p>
      <p className="additional-info">We're  still working on this page. Stay tuned for updates!</p>
    </div>
  );
}

export default CFS;
